export default "__VITE_ASSET__c1c634ec__"